import { render, staticRenderFns } from "./RoundedContainer.vue?vue&type=template&id=12f3ec34"
import script from "./RoundedContainer.vue?vue&type=script&lang=js"
export * from "./RoundedContainer.vue?vue&type=script&lang=js"
import style0 from "./RoundedContainer.vue?vue&type=style&index=0&id=12f3ec34&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports